<template>


	<Layout>
		<Sider hide-trigger>
			<my-menu></my-menu>
		</Sider>
		<Layout>
			<Content>
				<keep-alive v-if="isReloadData">
					<router-view></router-view>
				</keep-alive>
			</Content>
		</Layout>
	</Layout>


</template>
<script>
	import MyMenu from '@/components/project/mymenu/MyMenu.vue'

	export default {
		name: "MyProfile",
		props: {

		},
		components: {
			MyMenu,
		},
		data() {
			return {
				isReloadData: true,
			}
		},
		//暴露父页面的方法
		provide() {
			return {
				reload: this.reload
			};
		},
		methods: {
			//刷新事件
			reload() {
				this.isReloadData = false;
				this.$nextTick(() => {
					this.isReloadData = true;
				});
			}

		}
	}
</script>

<style lang="scss" scoped>
	.ivu-layout-sider {
		background: #ffffff;
	}
</style>
